import { Dialog, DialogActions, DialogContent, Tooltip, Typography } from "@mui/material";
import { useState } from "react";
import { countries } from "../../helpers/countries";
import { CancelIcon } from "../../icon";
import { FeaturesModel } from "../../models/features.model";
import { OrganizationModel } from "../../models/organization.model";
import { FeatureType, TierOccurrence } from "../../models/plans.model";
import ButtonComponent from "../shared/button/button.component";
import { buttonLabels } from "../shared/constants";

interface Props {
    name: string;
    price: number;
    footnote: string;
    product: number;
    country: string;
    features: any[];
    Features: FeaturesModel[];
    IsPrivate: boolean | -1;
    tierOccurrence: any;
    isLoading?: boolean;
    selectedOrganizations: string[];
    show: boolean;
    onClose: (isConfirm: boolean) => void;
    onSubmit: (e: any) => void;
    products: any;
    Organizations: OrganizationModel[];
}

const TierConformationComponent = (props: Props) => {
    let tierOccurrences = [{ Name: "One Time", Value: TierOccurrence.ONE_TIME }, { Name: "Recurring", Value: TierOccurrence.RECURRING }];
    const [subFeatures, setSubFeatures] = useState(props.Features.filter((item: FeaturesModel) => item.Type === FeatureType.MAIN));

    return <Dialog fullWidth maxWidth="sm"
        onClose={props.onClose}
        aria-labelledby="customized-dialog-title"
        open={props.show}
    >
        <DialogContent>

            <div style={{ height: "300px" }}>
                <div className="d-flex flex-direction-row justify-between mb-1">
                    {
                        <Typography className={`h2-semibold color-addon-text`}>{"$" + props.price}</Typography>
                    }
                    <Tooltip title='Close' placement='bottom'>
                        <span className="ml-auto">
                            <CancelIcon className={"c-pointer"} onClick={() => props.onClose(false)} />
                        </span>
                    </Tooltip>
                </div>
                <Typography className="h2-regular w-break mb-1 t-align-left">
                    {props.name}
                </Typography>

                <div className="d-flex flex-direction-row ">
                    <Typography className={`h4-regular color-primary`}>{"Product:"}</Typography>
                    <Typography className={`h4-semibold color-primary ml-1`}>{props.products.find(x => x.Value === props.product)?.Name}</Typography>
                </div>

                <div className="d-flex flex-direction-row ">
                    <Typography className={`h4-regular color-primary`}>{"Footnote:"}</Typography>
                    <Typography className={`h4-semibold color-primary ml-1`}>{props.footnote}</Typography>
                </div>

                <div className="d-flex flex-direction-row ">
                    <Typography className={`h4-regular color-primary`}>{"Private Add-On:"}</Typography>
                    <Typography className={`h4-semibold color-primary ml-1`}>{props.IsPrivate === false ? "False" : "True"}</Typography>
                </div>

                {
                    props.IsPrivate ? <div>
                        <Typography className={`h4-regular w-break color-primary`} gutterBottom>{"Organization List: "}</Typography>
                        {
                            props.selectedOrganizations.map((org, inx) => {
                                return <Typography className={`h5-semibold w-break color-primary`} gutterBottom>{inx + 1 + ". "}{props.Organizations.filter((or) => or.ID == org)[0]?.Name}</Typography>
                            })
                        }
                    </div> : <></>
                }
                <div className="d-flex flex-direction-row ">
                    <Typography className={`h4-regular color-primary`}>{"Tier Occurrence: "}</Typography>
                    <Typography className={`h4-semibold color-primary ml-1`}>{tierOccurrences.find(x => x.Value === props.tierOccurrence)?.Name}</Typography>
                </div>
                <div className="d-flex flex-direction-row ">
                    <Typography className={`h4-regular color-primary`}>{"Country:"}</Typography>
                    <Typography className={`h4-semibold color-primary ml-1`}>{countries.find(x => x.ISO === props.country)?.Name}</Typography>
                </div>

                {props.features.length > 0 &&
                    <div className="d-flex flex-direction-row ">
                        <Typography className={`h4-regular color-primary`}>{"Feature:"}</Typography>
                        <Typography className={`h4-semibold color-primary ml-1`}>{subFeatures.find(x => x.ID === props.features[0].ID)?.Name + ":  "}  {props.features[0].Value < 0 ? "Unlimited" : props.features[0].Value}</Typography>
                    </div>
                }
            </div>

        </DialogContent>
        <DialogActions className="">
            <ButtonComponent OnClick={() => props.onClose(false)} ButtonLabel={buttonLabels.CANCEL} Variant={"secondary-btn-small"} ClassName={"ml-auto mr-1"}/>
            <ButtonComponent
                OnClick={props.onSubmit}
                ButtonLabel={buttonLabels.CONFIRM_ADDON_NOW}
                Loading={props.isLoading}
                ClassName={"pl-4 pr-4"}
                Variant={"primary-btn-small"} />
        </DialogActions>
    </Dialog>

}

export default TierConformationComponent;